import * as React from "react";
const SvgFiRrBanner3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-banner-3_svg__a)">
      <path
        fill="#062147"
        d="M22.875.997A3.56 3.56 0 0 0 20.21.004L4.33.63A4.16 4.16 0 0 0 .393 4.337L.027 8.043a4.02 4.02 0 0 0 1.884 3.798l2.844 1.767-1.853 2.986c-.538.867-.896 1.692-.901 2.885h-.002v.295c0 1.322.826 2.488 2.09 2.871l4.387 1.33c.793.197 1.285-.837.63-1.327l-3.338-2.172-.025-.018 3.769-1.54a3.99 3.99 0 0 0 2.487-3.703v-3.637l7.643.42a4.16 4.16 0 0 0 3.069-1.153 4.13 4.13 0 0 0 1.288-3.015V3.62A3.58 3.58 0 0 0 22.875.996m-14.12 16.07-4.72 1.93c.069-.429.238-.82.566-1.348l1.853-2.985 3.018 1.875c-.198.22-.43.411-.716.528M10 14.511l-5.374-3.339 5.374.295zm12-6.68c0 .598-.238 1.155-.67 1.57a2.16 2.16 0 0 1-1.587.6l-17.641-.97a2 2 0 0 1-.083-.793l.364-3.69A2.16 2.16 0 0 1 4.42 2.626l15.88-.625c.447-.017.873.136 1.197.444S22 3.17 22 3.618z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-banner-3_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBanner3;
